import React, { Component } from 'react'
import NewRepositoryDialog from './NewRepositoryDialog'
import { createRepository } from './../../../store/repositories/actions'
import { connect } from 'react-redux'

const mapStateToProps = (state, props) => ({
  saving: state.loading[`creating-branch-${props.ownerId}`],
})

const mapDispatchToProps = (dispatch, { ownerId }) => ({
  createRepository: (newName) =>
    dispatch(createRepository(newName, ownerId))
})

class Container extends Component {

  componentWillReceiveProps = (newProps) => {
    if (newProps.saving != this.props.saving && this.props.saving == true)
      this.props.onClose()
  }

  render = () => {
    return <NewRepositoryDialog {...this.props} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)


// WEBPACK FOOTER //
// ./src/pages/RepositorySelect/NewRepositoryDialog/Container.js